export default {
  CHARACTER_COUNT: 6,
  STORE_CODE_MIN_LENGTH: 6,
  STORE_CODE_MAX_LENGTH: 6
};
